module.exports = __webpack_public_path__ + "img/TRIG.799b9823.svg";